<section class="promo-code">
  <button
    *ngIf="!hasPromoCode"
    class="promo-code__action"
    (click)="hasPromoCode = true"
  >
    Add Promo code
  </button>
  <form ngClass="promo-code__group" *ngIf="hasPromoCode" [formGroup]="code">
    <div
      [ngClass]="
        errorCoupon !== null
          ? 'promo-code__input not-found'
          : 'promo-code__input'
      "
    >
      <input
        type="text"
        required
        id="promo-code"
        [formControl]="code"
        placeholder="Enter promo code"
        (change)="errorCoupon = null"
      />
    </div>
    <button
      type="submit"
      class="promo-code__apply"
      [disabled]="code.value.length <= 0 || isLoading"
      (click)="handlePromoCode()"
    >
      <span *ngIf="!isLoading"> Apply </span>
      <img
        class="spinner"
        width="20px"
        height="20px"
        *ngIf="isLoading"
        src="assets/svg-icons/45deg-spinner.svg"
        alt="spinner loading"
      />
    </button>
  </form>
  <span *ngIf="errorCoupon !== null" class="promo-code__invalid">
    {{ errorCoupon }}
  </span>
</section>
